import { leasingAgreementState } from '../initialState';
import { storeRemoveItem, storeUpdateObjectInArray } from '../utils/utils';

// `error` is the last failed write's response body and `errorFormKey` the form
// it came from (an agreement id, or the new form's key), so a validation error
// shows under the right agreement. `savedFormKey` is set by a successful create
// so the new form can close itself.

function withStatus(state, loading, error, errorFormKey) {
  return Object.assign({}, state.leasingAgreementStatus, { loading, error, errorFormKey: errorFormKey || null });
}

export default function (state = leasingAgreementState, action) {
  switch (action.type) {
    case 'FETCH_LEASING_AGREEMENTS_REQUEST': {
      return { ...state, leasingAgreements: [], leasingAgreementStatus: withStatus(state, true, null) };
    }
    case 'FETCH_LEASING_AGREEMENTS_SUCCESS': {
      return { ...state, leasingAgreements: action.payload, leasingAgreementStatus: withStatus(state, false, null) };
    }
    case 'FETCH_LEASING_AGREEMENTS_FAIL': {
      return { ...state, leasingAgreements: [], leasingAgreementStatus: withStatus(state, false, action.payload) };
    }
    case 'CREATE_LEASING_AGREEMENT_REQUEST':
    case 'UPDATE_LEASING_AGREEMENT_REQUEST':
    case 'DELETE_LEASING_AGREEMENT_REQUEST': {
      return { ...state, savedFormKey: null, leasingAgreementStatus: withStatus(state, true, null) };
    }
    case 'CREATE_LEASING_AGREEMENT_SUCCESS': {
      return {
        ...state,
        leasingAgreements: [action.payload].concat(state.leasingAgreements),
        savedFormKey: action.additionalData.formKey,
        leasingAgreementStatus: withStatus(state, false, null),
      };
    }
    case 'UPDATE_LEASING_AGREEMENT_SUCCESS': {
      return {
        ...state,
        leasingAgreements: storeUpdateObjectInArray(state.leasingAgreements, action.payload),
        savedFormKey: action.additionalData.formKey,
        leasingAgreementStatus: withStatus(state, false, null),
      };
    }
    case 'DELETE_LEASING_AGREEMENT_SUCCESS': {
      return {
        ...state,
        leasingAgreements: storeRemoveItem(state.leasingAgreements, action.additionalData.itemId),
        leasingAgreementStatus: withStatus(state, false, null),
      };
    }
    case 'CREATE_LEASING_AGREEMENT_FAIL':
    case 'UPDATE_LEASING_AGREEMENT_FAIL':
    case 'DELETE_LEASING_AGREEMENT_FAIL': {
      return {
        ...state,
        leasingAgreementStatus: withStatus(state, false, action.payload, action.additionalData.formKey),
      };
    }
    default:
      break;
  }
  return state;
}
